module.exports = __webpack_public_path__ + "img/eliminar.652dc3c8.png";